import {
  getJobOpenings,
  getJobById
}
  from '~api/job-openings'

export const state = () => ({
  jobs: [],
  pages: {},
  currentJobDetails: {}
})

export const getters = {
  jobsGetter: state => state.jobs,
  pageGetter: state => state.pages,
  currentJobDetailsGetter: state => state.currentJobDetails
}

export const actions = {
  async getJobs ({ commit }, page) {
    const data = await getJobOpenings(page)
    const {
      jobs,
      pages
    } = data

    commit('setJobs', jobs)
    commit('setJobsPage', pages)

    return data
  },
  async getJobDetailsById ({ commit }, id) {
    const job = await getJobById(id)
    commit('setCurrentJobDetails', job)
  }
}

export const mutations = {
  setJobs (state, payload) {
    state.jobs = payload
  },
  setJobsPage (state, payload) {
    state.pages = payload
  },
  setCurrentJobDetails (state, payload) {
    state.currentJobDetails = payload
  }
}
